'use client'

import dynamic from 'next/dynamic'
import React from 'react'
import classNames from 'classnames'
import { useIntersectionObserver } from '@dustin-web/microsite-components/src/hooks'
import type { SliderType } from '@dustin-web/microsite-components/src/carousel-test/settings'
import type { ColorTheme } from '@dustin-web/styledust/constants'
import type { LandingPageGroupList } from '../data/types'
import { getBgColorThemeClass } from '../utils/color-theme'
import { isValidSingleListVariant } from '../utils/attributes'

const LandingPageSingleList = dynamic(() => import('./single-list'))
const LandingPageMultiList = dynamic(() => import('./multi-list'))

type Props = {
  key: string
  data: LandingPageGroupList[]
  lazyload?: boolean
  removeVerticalPadding?: boolean
  removeHorizontalPadding?: boolean
  sliderType?: SliderType
}

const LandingPageGroup = ({
  key,
  data: groupLists,
  lazyload,
  removeVerticalPadding,
  removeHorizontalPadding,
  sliderType,
}: Props) => {
  const { ref, isVisible } = useIntersectionObserver({})

  if (!groupLists?.length) {
    return
  }

  const isGroupVisible = !lazyload || (lazyload && isVisible)
  const [groupList] = groupLists ?? []

  const { colorTheme: groupColorTheme } = groupList.attributes ?? {}
  const colorTheme: ColorTheme = (groupColorTheme as ColorTheme) || 'gray'

  return (
    <div key={key} ref={ref} className={`${getBgColorThemeClass(colorTheme, 'light')}`}>
      {isGroupVisible ? (
        <div
          className={classNames('container', {
            'u-py-32 u-py-lg-48': !removeVerticalPadding,
            'u-pb-32 u-pb-lg-48': removeVerticalPadding,
            'u-px-0': removeHorizontalPadding,
          })}>
          <div className="row sm-gutters">
            {groupLists.length === 1 && isValidSingleListVariant(groupLists) ? (
              <LandingPageSingleList groupList={groupList} sliderType={sliderType} />
            ) : (
              <LandingPageMultiList groupLists={groupLists} />
            )}
          </div>
        </div>
      ) : null}
    </div>
  )
}

export default LandingPageGroup
